import { useEffect, useState } from "react";

function SoloMovilesWrapper({ children }) {
  const [esMovil, setEsMovil] = useState(true);

  useEffect(() => {
    const check = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent);
    setEsMovil(check);
  }, []);

  if (!esMovil) {
    return (
      <div style={{
        display: "flex",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        fontFamily: "sans-serif",
        textAlign: "center",
      }}>
        <h2>Solo disponible en dispositivos móviles</h2>
        <p>Por favor, abre esta página desde tu teléfono o tablet.</p>
      </div>
    );
  }

  return children;
}

export default SoloMovilesWrapper;